export default {
	user: {},
	subscriptions: [],
	paymentAttempts: [],
	token: null,
    use_home_as_billing: true,
	_widgetInstance: null,
	selectedUpgrade: { id: null, pricingOption: null },
	cancelSubscriptionsCheckboxes: {},

	// This is an id from the subscription_upgrades table - we get this back from our trustpay response handler (within the trustpay iframe)
	// Which passes it to the parent window and stores it here, so we can fetch a full purchase summary on the success screen.
	subscriptionUpgradeId: null,

	// The status from a trustpay payment: SUCCESS/CANCELLED etc.
	paymentStatus: null,

	// This holds a payment summary object for the successful payment screen
	payment: {}
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Widget/state.js